import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconWordPress = ({
  title = "WordPress",
  viewBoxWidth = 580,
  viewBoxHeight = 581,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <defs>
      <polygon
        id="path-1"
        points="0.06 0.989 580 0.989 580 580.94 0.06 580.94"
      />
    </defs>
    <g
      id="IconWordPress"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M41.223,290.984 C41.223,389.466 98.451,474.561 181.436,514.895 L62.761,189.738 C48.957,220.679 41.223,254.921 41.223,290.984"
        id="Fill-1"
        fill="#186B8A"
      />
      <path
        d="M457.955,278.433 C457.955,247.686 446.911,226.393 437.434,209.82 C424.829,189.327 413.011,171.972 413.011,151.479 C413.011,128.609 430.352,107.321 454.781,107.321 C455.885,107.321 456.929,107.46 458.011,107.52 C413.741,66.972 354.773,42.212 290.005,42.212 C203.089,42.212 126.626,86.805 82.14,154.35 C87.98,154.525 93.486,154.641 98.15,154.641 C124.171,154.641 164.457,151.484 164.457,151.484 C177.868,150.693 179.449,170.392 166.057,171.977 C166.057,171.977 152.573,173.563 137.576,174.349 L228.176,443.824 L282.624,280.536 L243.854,174.344 C230.457,173.557 217.766,171.972 217.766,171.972 C204.36,171.186 205.931,150.688 219.338,151.479 C219.338,151.479 260.422,154.636 284.868,154.636 C310.886,154.636 351.169,151.479 351.169,151.479 C364.59,150.688 366.166,170.386 352.765,171.972 C352.765,171.972 339.261,173.557 324.292,174.344 L414.198,441.78 L439.005,358.858 C449.768,324.445 457.955,299.73 457.955,278.433"
        id="Fill-2"
        fill="#186B8A"
      />
      <path
        d="M294.369,312.749 L219.726,529.643 C242.013,536.204 265.581,539.786 290.004,539.786 C318.976,539.786 346.759,534.77 372.62,525.681 C371.944,524.619 371.339,523.487 370.849,522.256 L294.369,312.749"
        id="Fill-3"
        fill="#186B8A"
      />

      <mask id="mask-2" fill="white">
        <use xlinkHref="#path-1" />
      </mask>
      <g id="Clip-5" />
      <path
        d="M508.303,171.625 C509.371,179.549 509.977,188.064 509.977,197.208 C509.977,222.454 505.262,250.834 491.06,286.319 L415.07,506.031 C489.032,462.9 538.779001,382.771 538.779001,290.984 C538.782,247.737 527.733,207.064 508.303,171.625"
        id="Fill-4"
        fill="#186B8A"
        mask="url(#mask-2)"
      />
      <path
        d="M290.005,567.703 C137.435,567.703 13.296,443.566 13.296,290.984 C13.296,138.419 137.426,14.293 290.005,14.293 C442.574,14.293 566.7,138.418 566.7,290.984 C566.7,443.568 442.57,567.703 290.005,567.703 Z M290.005,0.989 C130.098,0.989 0,131.083 0,290.985 C0,450.91 130.093,581.004 290.005,581.004 C449.906,581.004 580.025,450.914 580.025,290.985 C580.025,131.082 449.906,0.989 290.005,0.989 L290.005,0.989 Z"
        id="Fill-6"
        fill="#186B8A"
        mask="url(#mask-2)"
      />
    </g>
  </Svg.Icon>
)

export default IconWordPress
